import React, { Component } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import SignOff from '../components/sign-off';
import Subscribe from '../components/subscribe';
import ArticleCard from '../components/cards/article';
import ArticleFeature from '../components/cards/article-feature';
import Select from 'react-select';
import { Search } from '../components/icons';

const categories = [
  { label: "All News", value: "" },
  { label: "Commercial", value: "Commercial" },
  { label: "Residential", value: "Residential" },
  { label: "New Projects", value: "New Projects" },
  { label: "Property Management", value: "Property Management" },
  { label: "Community", value: "Community" },
  { label: "Market Insights", value: "Market Insights" },
  { label: "Magazine", value: "Magazine" },
  { label: "Achievements", value: "Achievements" },
];

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: props.data.news?.nodes || [],
      limit: 6,
      filter: '',
      search: '',
    };
    this.load = React.createRef();
    this.scrollTimeout = null;
  }

  componentDidMount() {
  window.addEventListener('scroll', this.handleScroll);

  // Read ?category=… from the browser URL
  if (typeof window !== 'undefined' && window.location.search) {
    const params   = new URLSearchParams(window.location.search);
    const catParam = params.get('category'); // e.g. "property-management"
    if (catParam) {
      const matched = categories.find(cat =>
        cat.value.toLowerCase().replace(/\s+/g, '-') === catParam
      );
      if (matched) {
        this.applyFilters(matched.value, this.state.search);
      }
    }
  }
}

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
  }

  handleScroll = () => {
    if (!this.load.current) return;
    const pos = this.load.current.getBoundingClientRect();
    if (pos.top >= 0 && pos.bottom <= window.innerHeight) {
      if (!this.scrollTimeout) {
        this.scrollTimeout = setTimeout(() => {
          this.setState(st => ({ limit: st.limit + 6 }));
          this.scrollTimeout = null;
        }, 100);
      }
    }
  };

  handleCategoryChange = (selectedOption) => {
    const filter = selectedOption ? selectedOption.value : '';
    this.applyFilters(filter, this.state.search);
  };

  handleSearchChange = (e) => {
    const search = e.target.value;
    this.applyFilters(this.state.filter, search);
  };

  applyFilters = (filter, search) => {
    const { news } = this.props.data;
    let items = news.nodes;

    if (filter) {
      items = items.filter(n =>
        n.categories.nodes.some(c => c.name === filter)
      );
    }
    if (search) {
      items = items.filter(n =>
        n.title.toLowerCase().includes(search.toLowerCase())
      );
    }

    this.setState({ display: items, filter, search });
  };

  render() {
    const { display, limit, filter } = this.state;

    // ensure the Select reflects our filter
    const selectedOption = categories.find(cat => cat.value === filter);

    return (
      <section className="news search-team">
        {display.length > 0 && <ArticleFeature feature {...display[0]} />}
        {display.length === 0 && <div className="news__no-results" />}

        <div className="news__inner form">
          <form className="form__row form__row--search" onSubmit={e => e.preventDefault()}>
            <input
              type="text"
              name="search"
              placeholder="Search all topics"
              onChange={this.handleSearchChange}
              value={this.state.search}
            />
            <button type="submit"><Search /></button>
          </form>

          <div className="form__row form__row--dropdowns">
            <div className="form__select form__select--area">
              <Select
                options={categories}
                value={selectedOption}
                onChange={this.handleCategoryChange}
                placeholder="All News"
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          </div>

          <ul className="news__filter">
            <li>
              <button
                className={!filter ? 'active' : ''}
                type="button"
                onClick={() => this.applyFilters('', this.state.search)}
              >
                All News
              </button>
            </li>
            {categories
              .filter(cat => cat.value)
              .map(cat => (
                <li key={cat.value}>
                  <button
                    className={filter === cat.value ? 'active' : ''}
                    type="button"
                    onClick={() => this.applyFilters(cat.value, this.state.search)}
                  >
                    {cat.label}
                  </button>
                </li>
              ))}
          </ul>
        </div>

        <div className="news__inner">
          {display.slice(0, limit).map((node, i) => (
            <ArticleCard key={node.databaseId || i} {...node} />
          ))}
          {display.length === 0 && (
            <div className="news__none">
              <p>No articles found. Please search again.</p>
            </div>
          )}
        </div>

        <div ref={this.load} />
      </section>
    );
  }
}

export default function NewsQuery(props) {
  return (
    <StaticQuery
      query={graphql`
        query NewsQuery {
          news: allWpPost(sort: { date: DESC }) {
            nodes {
              databaseId
              id
              slug
              title
              date(formatString: "MMMM D YYYY")
              categories { nodes { slug name } }
              featuredImage { node { sourceUrl altText } }
              acf {
                author { ... on WpTeamMember {
                  title
                  acf { thumbnailImage { altText sourceUrl } }
                }}
                externalAuthor { name position image { sourceUrl } }
              }
            }
          }
        }
      `}
      render={data => <News data={data} {...props} />}
    />
  );
}
